import useMap from '../../../hooks/use-map';
import { useSafeEffect } from '../../../hooks/use-safe-effect';
import { useWorkspaceView } from '../hooks/use-view';

const id = 'fe-brightness';

export default function BrightnessLayer() {
    const map = useMap();
    const value = useWorkspaceView((x) => x.staticData.miscellaneous.backGroundBrightness);

    useSafeEffect(() => {
        if (!map) {
            return;
        }

        if (map.getLayer(id)) {
            return;
        }

        map.addSource(id, {
            type: 'geojson',
            data: {
                type: 'Polygon',
                coordinates: [
                    [
                        [-180, 90],
                        [180, 90],
                        [180, -90],
                        [-180, -90]
                    ]
                ]
            }
        });
        map.addLayer(
            {
                id: id,
                type: 'fill',
                source: id,
                paint: {
                    'fill-color': 'black',
                    'fill-opacity': valueToOpacity(value),
                    'fill-outline-color': 'transparent'
                }
            },
            'fe-brightness-slot'
        );

        return () => {
            if (map.getLayer(id)) {
                map.removeLayer(id);
                map.removeSource(id);
            }
        };
    }, [map]);

    if (map && map.getLayer(id)) {
        map.setPaintProperty(id, 'fill-opacity', valueToOpacity(value));
    }

    return null;
}

function valueToOpacity(value: number): number {
    return 1 - (value + 45) / 300;
}
